
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27.022","height":"24.133","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 669"}},[_c('path',{attrs:{"data-name":"Path 6779","d":"M5.193 21.529v2.1H2.178v-2.428m.008-3.658c.694-.157 3.028.884 2.273 1.621m10.719 2.367v2.1h3.015v-2.43m-3.788-2.89c-.081 1.569-2.08 1.731-4.219 1.814-2.142-.083-4.139-.245-4.219-1.814l4.219.042 4.219-.042zm3.781-.768c-.7-.157-3.029.884-2.275 1.621m1.119-6.389c-.419-1.047-1.464-3.194-1.729-3.62-.683-1.1-3.464-1.082-5.115-1.063-1.653-.019-4.434-.034-5.116 1.063-.265.426-1.31 2.573-1.73 3.62m6.846 8.8c-1.931.016-5.27.017-6.4-.156-1.632-.249-2.812-.794-2.812-1.716s-.022-1.718.008-2.613a6.767 6.767 0 012.361-4.318c1.239.878 4.343 1.377 6.846 1.426 2.5-.049 5.6-.548 6.844-1.426a6.764 6.764 0 012.362 4.318c.03.895.008 1.691.008 2.613s-1.429 1.505-2.811 1.716a56.742 56.742 0 01-6.4.156zm-6.451-9.99c-.448-.663-2.249-1.186-2.436-.52A1.786 1.786 0 002.86 13.24m13.776-1.655c.447-.663 2.25-1.186 2.437-.52a1.787 1.787 0 01-1.562 2.175m-6.9-1.116l2.075-2.075m-4.995 2.075l2.075-2.075"}}),_c('path',{attrs:{"data-name":"Path 6780","d":"M15.306.586c-3.475.673-6.754 1.093-6.866 1.653-.165.825 9.769 2.931 10.561 3.56.475.377.408.78-.669 1.177C12.439 8.211-.057 8.008.523 12.538M23.656.592c-3.475.672-9.919 1.316-10.032 1.877-.117.583 10.734 2.042 12.287 2.948 2.85 1.666-5.23 4.879-8.638 6.616"}})])])
          )
        }
      }
    